import React, { useCallback, useEffect, useRef } from 'react'
import GoogleMapReact, { ChangeEventValue } from 'google-map-react'
import Div from 'src/components/atomic/atom/Div'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import LocationDetailModal from 'src/components/atomic/organisms/views/Location/LocationDetailModal'
import { GoogleMapDataPropsType } from 'src/components/etc/GoogleMap/index'
import { SvcLocationType } from 'src/types/websocket'
import NumberMarker from 'src/components/atomic/atom/NumberMarker'
import NowMarker from 'src/components/atomic/atom/NowMarker'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { setMapCenterPosition } from 'src/store/Reducer/page/locationPageSlice'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'

const GOOGLE_MAP_KEY = { key: `${process.env.REACT_APP_GOOGLE_MAP_KEY}` }

const GoogleMapTemplate = (props: { data: GoogleMapDataPropsType }) => {
  const { NowMarkerDispatch, NumMarkerDispatch } = props.data

  const dispatch = useAppDispatch()
  const { LocationInfos } = useAppSelector((state: RootState) => state.locationHistory)
  const { XVal, YVal, Address } = useAppSelector((state: RootState) => state.currentLocation)
  const { selectPin, mapCenterPosition } = useAppSelector((state: RootState) => state.LocationPage)
  const { currentMedia, setMediaStyle } = useMediaQueryHook()
  const locationDetailModalRef = useRef<HTMLDivElement>(null)
  const moveMapCenterHandler = useCallback(
    (lat: number, lng: number) => {
      dispatch(setMapCenterPosition({ lat: lat ?? 0, lng: lng ?? 0 }))
    },
    [dispatch],
  )

  const detailModalHeight = locationDetailModalRef.current?.offsetHeight ?? 0
  // 맵 최초 로드시 표시되는 좌표 설정
  // 우선순위) 1: 현재위치, 2: 마지막 위치
  useEffect(() => {
    if (XVal === '' && YVal === '') {
      moveMapCenterHandler(
        Number(LocationInfos?.length > 0 ? LocationInfos[0].XVal : 0) ?? 0,
        Number(LocationInfos?.length > 0 ? LocationInfos[0].YVal : 0) ?? 0,
      )
    } else {
      moveMapCenterHandler(Number(XVal), Number(YVal))
    }
  }, [XVal, YVal, LocationInfos, moveMapCenterHandler])

  // 구글 맵 로드시 option 설정
  const createMapOptions = () => {
    return {
      //api 기본 UI
      disableDefaultUI: false,
      // map, satellite
      mapTypeControl: true,
      //사람 아이콘
      streetViewControl: true,
      styles: [
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{ visibility: 'on' }],
        },
      ],
    }
  }

  return (
    <Div
      width={'100%'}
      height={setMediaStyle('100vh', '100vh', `calc(100vh - ${detailModalHeight}px - 40px)`)}
      $min_height={currentMedia === 'pc' ? '945px' : 'unset'}
      style={{
        position: currentMedia === 'mobile' ? 'absolute' : 'unset',
        top: currentMedia === 'mobile' ? '48px' : 'unset',
      }}
    >
      <GoogleMapReact
        bootstrapURLKeys={GOOGLE_MAP_KEY}
        options={createMapOptions}
        center={mapCenterPosition}
        zoom={16}
        onChange={(value: ChangeEventValue) => {
          moveMapCenterHandler(value.center.lat, value.center.lng)
        }}
      >
        {LocationInfos.map((element: SvcLocationType) => (
          <NumberMarker
            key={element.Idx}
            lat={Number(element.XVal)}
            lng={Number(element.YVal)}
            markerText={element.Idx.toString()}
            active={selectPin?.Idx === element.Idx}
            onClickFn={() => {
              NumMarkerDispatch(element)
              moveMapCenterHandler(Number(element.XVal), Number(element.YVal))
            }}
          />
        ))}
        {XVal && YVal && Address && (
          <NowMarker
            lat={Number(XVal)}
            lng={Number(YVal)}
            active={selectPin?.Idx === -1}
            onClickFn={() => {
              NowMarkerDispatch()
              moveMapCenterHandler(Number(XVal), Number(YVal))
            }}
          />
        )}
      </GoogleMapReact>
      <LocationDetailModal ref={locationDetailModalRef} />
    </Div>
  )
}
export default GoogleMapTemplate
